export default class scroll {
    constructor() {
        this.example = null;
        this.el = null;
    }

    init(toTop=true){
        $(()=>{
            let {example, el} = this;
            if(!el){
                this.el = el = $("html");
            }
            if(example){
                example.remove();
                toTop && window.scrollTo({top: 0});
            }

            this.example = el.addClass("x-smooth-scroll").niceScroll({
                    touchbehavior: false,
                    grabcursorenabled: false,
                    preservenativescrolling: true,
                    scrollspeed: 100,
                    mousescrollstep: 50
            });
        });
    }

    to(val){
        this.example.doScrollTop(val);
    }
}